import React from 'react';

import { Box } from '~/eds/src/components/Box/Box';
import { ErrorPage } from '~/eds/src/components/ErrorPage/ErrorPage';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const { navigate } = useRouting();
  const navigateBack = () => navigate(RoutePathType.Home);

  return (
    <Box mt={100}>
      <ErrorPage
        preset="page-access"
        resolveAction={{ onClick: navigateBack }}
      />
    </Box>
  );
};

export default Page;
